export default {
  calendar_team: (state) => {
    return state.calendar_team.filter(e => e.is_workday);
  }
}
